class SwiperVidjet {
  constructor(startEvent, isTouchable, endEvent, isHorizontal = false) {
    this.startEvent = startEvent;
    this.endEvent = endEvent || null;
    this.isTouchable = isTouchable;
    this.isHorizontal = isHorizontal;
  }

  getSwipeDirection() {
    const swipeThreshold = 30;
    const start = this.isTouchable 
      ? this.startEvent.changedTouches[0] 
      : this.startEvent;
    const end = this.isTouchable 
      ? this.endEvent?.changedTouches[0] 
      : this.endEvent;
  
    if (!start || !end) return null;
  
    if (this.isHorizontal) {
      const diffX = end.clientX - start.clientX;
      if (diffX <= -swipeThreshold) return "left";
      if (diffX >= swipeThreshold) return "right";
    } else {
      const diffY = start.clientY - end.clientY;
      if (diffY >= swipeThreshold) return "up";
      if (diffY <= -swipeThreshold) return "down";
    }
  
    return null;
  }

  isSwipeUp() {
    return this.getSwipeDirection() === "up";
  }

  isSwipeDown() {
    return this.getSwipeDirection() === "down";
  }

  getDeltaX() {
    let start = this.isTouchable
      ? this.startEvent.changedTouches[0]
      : this.startEvent;
    let end = this.isTouchable
      ? this.endEvent.changedTouches[0]
      : this.endEvent;
    if (!start || !end) {
      return null;
    }
    return this.isTouchable
      ? start.screenX - end.screenX
      : start.clientX - end.clientX;
  }

  setEndEvent(endEvent) {
    this.endEvent = endEvent;
  }
}

export default SwiperVidjet;